import * as actionTypes from '../types/undercut';

export function getUndercutList(payload) {
  return {
    type: actionTypes.GET_UNDERCUT_LIST,
    payload
  };
}

export function getUndercutListSuccess(payload) {
  return {
    type: actionTypes.GET_UNDERCUT_LIST_SUCCESS,
    payload
  };
}

export function getUndercutListFail(payload) {
  return {
    type: actionTypes.GET_UNDERCUT_LIST_FAIL,
    payload
  };
}

export function getUndercutOperation(payload) {
  return {
    type: actionTypes.GET_UNDERCUT_OPERATION,
    payload
  };
}

export function getUndercutOperationSuccess(payload) {
  return {
    type: actionTypes.GET_UNDERCUT_OPERATION_SUCCESS,
    payload
  };
}

export function getUndercutOperationFail(payload) {
  return {
    type: actionTypes.GET_UNDERCUT_OPERATION_FAIL,
    payload
  };
}

export function getUndercutTypesList(payload) {
  return {
    type: actionTypes.GET_UNDERCUT_TYPES_LIST,
    payload
  };
}

export function getUndercutTypesListSuccess(payload) {
  return {
    type: actionTypes.GET_UNDERCUT_TYPES_LIST_SUCCESS,
    payload
  };
}

export function getUndercutTypesListFail(payload) {
  return {
    type: actionTypes.GET_UNDERCUT_TYPES_LIST_FAIL,
    payload
  };
}

export function saveUndercut(payload) {
  return {
    type: actionTypes.SAVE_UNDERCUT,
    payload
  };
}

export function saveUndercutSuccess(payload) {
  return {
    type: actionTypes.SAVE_UNDERCUT_SUCCESS,
    payload
  };
}

export function saveUndercutFail(payload) {
  return {
    type: actionTypes.SAVE_UNDERCUT_FAIL,
    payload
  };
}

export function deleteUndercut(payload) {
  return {
    type: actionTypes.DELETE_UNDERCUT,
    payload
  };
}

export function deleteUndercutSuccess(payload) {
  return {
    type: actionTypes.DELETE_UNDERCUT_SUCCESS,
    payload
  };
}

export function deleteUndercutFail(payload) {
  return {
    type: actionTypes.DELETE_UNDERCUT_FAIL,
    payload
  };
}

export function stornoUndercut(payload) {
  return {
    type: actionTypes.STORNO_UNDERCUT,
    payload
  };
}

export function stornoUndercutSuccess(payload) {
  return {
    type: actionTypes.STORNO_UNDERCUT_SUCCESS,
    payload
  };
}

export function stornoUndercutFail(payload) {
  return {
    type: actionTypes.STORNO_UNDERCUT_FAIL,
    payload
  };
}

export function confirmUndercut(payload) {
  return {
    type: actionTypes.CONFIRM_UNDERCUT,
    payload
  };
}

export function confirmUndercutSuccess(payload) {
  return {
    type: actionTypes.CONFIRM_UNDERCUT_SUCCESS,
    payload
  };
}

export function confirmUndercutFail(payload) {
  return {
    type: actionTypes.CONFIRM_UNDERCUT_FAIL,
    payload
  };
}

export function getUndercutConfirmList(payload) {
  return {
    type: actionTypes.GET_UNDERCUT_CONFIRM_LIST,
    payload
  };
}

export function getUndercutConfirmListSuccess(payload) {
  return {
    type: actionTypes.GET_UNDERCUT_CONFIRM_LIST_SUCCESS,
    payload
  };
}

export function getUndercutConfirmListFail(payload) {
  return {
    type: actionTypes.GET_UNDERCUT_CONFIRM_LIST_SUCCESS,
    payload
  };
}
